import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
//import { List } from 'material-ui/List';
import List from '@material-ui/core/List';
import {
  archiveCase,
  deleteCase,
  showConfirmModal,
  unarchiveCase,
} from '../../redux/actions';
import { InboxListItemValidation } from '..';


class InboxListValidation extends PureComponent {
  render() {
    const {
      specimenArray,
      submitted,
      notSubmitted,
      numberOfSubmittedSpecimen,
      //numberOfNotSubmittedSpecimen, //for some reason it doesn't work to add this here.
      totalNumberOfSpecimen,
      selectedSpecimenId,
      handleSpecimenSelected,
      handleCollapse,
    } = this.props;

    return (
      <List className="validation__sidebar__list">

      <div className="validation__sidebar__category-header">
          <div>Not Submitted</div>
          <div>{this.props.numberOfNotSubmittedSpecimen}/{totalNumberOfSpecimen}</div>
        </div>

        {notSubmitted.map((specimen) => {
          let isSelected = false;
          if (selectedSpecimenId === specimen._id) {
            isSelected = true;
          }
          return (
            <InboxListItemValidation
              specimenArray={specimenArray}
              key={specimen._id}
              id={specimen._id}
              isSelected={isSelected}
              title={specimen.id}
              specimen={specimen}
              handleSpecimenSelected={handleSpecimenSelected}
              handleCollapse = {handleCollapse}
            />
          );
        })}

        <div className="validation__sidebar__category-header">
          <div>Submitted</div>
          <div>{numberOfSubmittedSpecimen}/{totalNumberOfSpecimen}</div>
        </div>

        {submitted.map((specimen) => {
          let isSelected = false;
          if (selectedSpecimenId === specimen._id) {
            isSelected = true;
          }
          return (
            <InboxListItemValidation
              specimenArray={specimenArray}
              key={specimen._id}
              id={specimen._id}
              isSelected={isSelected}
              title={specimen.id}
              specimen={specimen}
              handleSpecimenSelected={handleSpecimenSelected}
              handleCollapse = {handleCollapse}
            />
          );
        })}
      </List>
    );
  }
}

InboxListValidation.defaultProps = {
  selectedCaseId: '',
};

export default connect(
  null,
  {
    deleteCase,
    archiveCase,
    unarchiveCase,
    showConfirmModal,
  },
)(InboxListValidation);
